/* eslint-disable react/prop-types */
import CollectionSelect from "metabase/containers/CollectionSelect";

const FormCollectionWidget = ({ field }) => <CollectionSelect {...field} />;

export default FormCollectionWidget;
